// TODO: Check if we really need to use this store
import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { effect, inject } from '@angular/core';
import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';

import { MenuItem, RouteCodeEnum } from '@models/menu';
import { SearchFilter } from '@models/search';
import { UserStore } from '@signal-store/index';

enum SearchStoreActions {
  SetFilter = '[Search] SetFilter',
  SetSearchText = '[Search] SetSearchText',
  ClearFilter = '[Search] ClearFilter',
}

type SearchState = {
  searchText: string;
  filter: Partial<SearchFilter>;
};

const initialState: SearchState = {
  searchText: '',
  filter: {
    moduleIds: null,
    contractId: null,
    userId: null,
    period: null,
    startDate: null,
    endDate: null,
    matchAll: null,
    statusTypes: [],
  },
};

export const SearchStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withDevtools('search'),

  withMethods(store => {
    const setFilter = (searchFilter: Partial<SearchFilter>) => {
      updateState(store, SearchStoreActions.SetFilter, ({ filter }) => ({ filter: { ...filter, ...searchFilter } }));
    };

    const setSearchText = (searchedText?: string) => {
      updateState(store, SearchStoreActions.SetSearchText, { searchText: searchedText });
    };

    const clearFilter = () => {
      updateState(store, SearchStoreActions.ClearFilter, initialState);
    };

    return {
      setFilter,
      setSearchText,
      clearFilter,
    };
  }),

  withHooks({
    onInit: store => {
      const userStore = inject(UserStore);

      const checkMenuItems = (menuItems: MenuItem[]) =>
        (menuItems ?? [])
          .filter(
            m =>
              m &&
              (m.moduleId > 0 ||
                m.code === RouteCodeEnum.SOV ||
                m.code === RouteCodeEnum.ProgressPayment ||
                m.code === RouteCodeEnum.ChangeOrder),
          )
          .sort((m1, m2) => m1.name.localeCompare(m2.name))
          .map(m => m.moduleId?.toString())
          .filter(m => !!m);

      effect(() => {
        const contractId = userStore.contract()?.id;
        store.setFilter({ contractId });
      });

      effect(() => {
        const activeMenuItem = userStore.menu.activeMenuItem();

        let moduleIds = checkMenuItems([activeMenuItem]);
        if (!moduleIds.length) {
          moduleIds = checkMenuItems(userStore.menuItemsList());
        }
        store.setFilter({ moduleIds });
      });
    },
  }),
);
